// Description: Predictive search script for the theme.

async function getJSON(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to fetch: ${url}`);
  return await res.json();
}

function buildResultItemElements(resultEntries) {
  const template = document.querySelector('[data-predictive-result]');
  return resultEntries.map((suggestion) => {
    const el = template.content.cloneNode(true);

    const link = el.querySelector('[data-predictive-result-link]');
    const title = el.querySelector('[data-predictive-result-title]');
    link.href = suggestion.url;
    title.innerHTML = suggestion.title;

    return el;
  });
}

async function buildPredictiveSearchResultElements(query, data, element) {
  const container = element.closest('form').parentElement.querySelector('[data-predictive-result-container]');
  container.innerHTML = ''; // Clear previous

  const articles = data.results?.articles || [];
  if (articles.length > 0) {
    const title = document.createElement('h3');
    title.textContent = 'Blog posts';
    container.appendChild(title);

    const list = document.createElement('ul');
    list.classList.add('predictive-search-result-list');
    list.replaceChildren(...buildResultItemElements(articles));
    container.appendChild(list);

    // const buttonIcon = `Liquid error: This liquid context does not allow includes.`;
    const buttonIcon = `<svg class="icon-double-arrow" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Icon Double Arrow</title>
      <g clip-path="url(#clip0_2171_4966)">
      <path d="M2.73223 4.14645C2.9275 4.34171 2.9275 4.65829 2.73223 4.85355L0.146446 7.43934C-0.0488158 7.6346 -0.0488153 7.95119 0.146447 8.14645L0.853554 8.85355C1.04882 9.04882 1.3654 9.04881 1.56066 8.85355L5.56066 4.85355C5.75592 4.65829 5.75592 4.34171 5.56066 4.14645L1.56066 0.146446C1.3654 -0.0488157 1.04882 -0.0488154 0.853554 0.146447L0.146447 0.853554C-0.0488153 1.04882 -0.0488153 1.3654 0.146447 1.56066L2.73223 4.14645Z" fill="url(#paint0_linear_2171_4966)"></path>
      <path d="M8.43933 4.14645C8.63459 4.34171 8.63459 4.65829 8.43933 4.85355L5.85354 7.43934C5.65828 7.6346 5.65828 7.95119 5.85354 8.14645L6.56065 8.85355C6.75591 9.04882 7.07249 9.04881 7.26775 8.85355L11.2678 4.85355C11.463 4.65829 11.463 4.34171 11.2678 4.14645L7.26775 0.146446C7.07249 -0.0488157 6.75591 -0.0488154 6.56065 0.146447L5.85354 0.853554C5.65828 1.04882 5.65828 1.3654 5.85354 1.56066L8.43933 4.14645Z" fill="url(#paint1_linear_2171_4966)"></path>
      </g>
      <defs>
      <linearGradient id="paint0_linear_2171_4966" x1="2.85355" y1="0" x2="2.85355" y2="9" gradientUnits="userSpaceOnUse">
      <stop stop-color="#151515"></stop>
      <stop offset="1" stop-color="#151515"></stop>
      </linearGradient>
      <linearGradient id="paint1_linear_2171_4966" x1="8.56064" y1="0" x2="8.56064" y2="9" gradientUnits="userSpaceOnUse">
      <stop stop-color="#151515"></stop>
      <stop offset="1" stop-color="#151515"></stop>
      </linearGradient>
      <clipPath id="clip0_2171_4966">
      <rect width="12" height="9" fill="white"></rect>
      </clipPath>
      </defs>
    </svg>
  `;

    const viewAll = document.createElement('button');
    viewAll.type = 'submit';
    viewAll.innerHTML = `<span class="button-text">Search for "${query}"</span><span class="button-icon">${buttonIcon}</span>`;
    viewAll.setAttribute('class', 'search-button button btn-text');
    container.appendChild(viewAll);


  } else if (query.length > 0) {
    const noResults = document.createElement('p');
    noResults.textContent = `No blog posts found for "${query}"`;
    container.appendChild(noResults);
  }
}

function buildPredictiveSearchURL(query) {
  return `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article`;
}

window.ADDISON = window.ADDISON || {};
window.ADDISON.predictiveSearchHandler = async function (query, element) {
  console.log('Predictive search handler triggered');
  
  const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article`;

  const res = await fetch(url);
  const json = await res.json();
  const results = json.resources || {};

  await buildPredictiveSearchResultElements(query, results, element);
};
